import React from 'react';
import InventoryWidgetTableHeader from './InventoryWidgetTableHeader';
import { InventoryWidgetTableRow } from './InventoryWidgetTableRow';
import { useStyles } from './styles';
import Toggler from './Toggler';
import { NoAlerts } from '../../NoAlerts/NoAlerts';
const InventoryWidgetTable = (props) => {
    const classes = useStyles();
    const { filteredInventory, viewMode, setViewMode, criticalCount, earlyCount } = props;
    const rows = filteredInventory
        ? filteredInventory.map(({ id, stockDaysLeft, deliveryDelay, description, stockPerc, orderDate, orderControl }) => (React.createElement(InventoryWidgetTableRow, { key: id, id: id, stockDaysLeft: stockDaysLeft, deliveryDelay: deliveryDelay, description: description, stockPerc: stockPerc, orderDate: orderDate, orderControl: orderControl })))
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("table", { className: classes.table },
            React.createElement(Toggler, { viewMode: viewMode, setViewMode: setViewMode, criticalCount: criticalCount, earlyCount: earlyCount }),
            React.createElement(InventoryWidgetTableHeader, null),
            rows),
        !(rows === null || rows === void 0 ? void 0 : rows.length) && (React.createElement("div", { className: classes.alertsWrapper },
            React.createElement(NoAlerts, null)))));
};
export default InventoryWidgetTable;
//# sourceMappingURL=InventoryWidgetTable.js.map